<template>
    <div class="container">
        <form class="login-form" @submit.prevent>
            <b-notification v-bind:type="$store.state.ui.toastType" :active="$store.state.ui.toast" :closable="false">
                {{ $store.state.ui.toastMessage }}
            </b-notification>

            <div class="splash">Blackblox</div>

            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" :class="{ error: showErrorsState('email') }" type="email" :placeholder="$t('login.email')" name="email" v-model="user.email" required
                           autofocus autocapitalize="none"/>
                    <span class="icon is-small is-left">
                        <i class="fas fa-user"></i>
                    </span>
                </div>
            </div>

            <div class="field">
                <div class="control has-icons-left has-icons-right">
                    <input class="input" :class="{ error: showErrorsState('password') }" type="text" :placeholder="$t('login.password')" name="password"
                           v-model="user.password" minlength="8" required autocomplete="off"/>
                    <span class="icon is-small is-left">
                        <i class="fas fa-key"></i>
                    </span>
                </div>
            </div>

            <div class="field">
                <div class="control has-icons-left has-icons-right">
                    <input class="input" :class="{ error: showErrorsState('confirmPassword') }" type="text" :placeholder="$t('registration.confirm_password')" name="confirmPassword"
                           v-model="user.confirmPassword" minlength="8" required autocomplete="off"/>
                    <span class="icon is-small is-left">
                        <i class="fas fa-key"></i>
                    </span>
                </div>
            </div>

            <div v-if="passwordsNotEqual" style="margin-bottom: 20px; color: #f1504e;">
                {{ $t('registration.passwords_not_equal') }}
            </div>

            <div v-if="showErrors && user.password.length < 8" style="margin-bottom: 20px; color: #f1504e;">
                {{ $t('registration.password_minimum_length') }}
            </div>

            <div class="field">
                <div class="control has-icons-left has-icons-right">
                    <input class="input" :class="{ error: showErrorsState('firstName') }" type="text" :placeholder="$t('registration.first_name')" name="firstName"
                           v-model="user.firstName" required/>
                    <span class="icon is-small is-left">
                        <i class="fas fa-user"></i>
                    </span>
                </div>
            </div>

            <div class="field">
                <div class="control has-icons-left has-icons-right">
                    <input class="input" :class="{ error: showErrorsState('lastName') }" type="text" :placeholder="$t('registration.last_name')" name="lastName"
                           v-model="user.lastName" required/>
                    <span class="icon is-small is-left">
                        <i class="fas fa-user"></i>
                    </span>
                </div>
            </div>

            <div class="field">
                <div class="control has-icons-left has-icons-right">
                    <input class="input" :class="{ error: showErrorsState('address') }" type="text" :placeholder="$t('registration.address')" name="address"
                           v-model="user.address" required/>
                    <span class="icon is-small is-left">
                        <i class="fas fa-map-marker-alt"></i>
                    </span>
                </div>
            </div>

            <div v-if="phoneFormatNotEqual" style="margin-bottom: 10px;">
                {{ $t('registration.phone_format') }}: +38012345678
            </div>

            <div class="field">
                <div class="control has-icons-left has-icons-right">
                    <input class="input" :class="{ error: showErrorsState('phone') }" type="text" :placeholder="$t('registration.phone')" name="phone"
                           v-model="user.phone" required minlength="10" maxlength="15" pattern="^\+\d{1,3}\d{8,12}$"/>
                    <span class="icon is-small is-left">
                        <i class="fas fa-phone"></i>
                    </span>
                </div>
            </div>

            <div class="field">
                <select name="locale" v-model="user.locale" class="input select" style="padding-bottom: 10px;" required placeholder="${g.message(code:'registration.locale')}">
                    <option value="sl">Slovenščina</option>
                    <option value="en">English</option>
                    <option value="de">Deutsch</option>
                    <option value="it">Italiano</option>
                    <option value="hr">Hrvatski</option>
                    <option value="cz">Čeština</option>
                    <option value="el">Ελληνικά</option>
                </select>
            </div>

            <button
                class="g-recaptcha button is-primary"
                data-sitekey="${process.env.VUE_APP_CAPTCHA_SITE_KEY}"
                data-action="submit"
                type="submit"
                @click.prevent="onSubmit"
            >
                {{ $t('registration.register') }}
            </button>
        </form>
    </div>
</template>

<script>
export default {
    name: 'RegistrationView',
    data() {
        return {
            user: {
                email: '',
                password: '',
                confirmPassword: '',
                firstName: '',
                lastName: '',
                address: '',
                phone: '',
                locale: 'sl'
            },
            showErrors: false
        };
    },
    methods: {
        async doRegistration() {
            const data = {
                username: this.user.email,
                email: this.user.email,
                password: this.user.password,
                name: this.user.firstName,
                lastName: this.user.lastName,
                address: this.user.address,
                phone: this.user.phone,
                preferredLocale: this.user.locale
            };
            try {
                let API_URL = process.env.VUE_APP_API_BASE_USER_ACCOUNT;
                // Make the API call to check registration status
                const response = await fetch(API_URL + '/api/public/users/register', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                });

                // Check if the response content type is JSON
                const contentType = response.headers.get("Content-Type");

                if (contentType && contentType.includes("application/json")) {
                    const data = await response.json(); // Parse JSON if content type is JSON
                    if (data.isSuccess === true) {
                        this.$store.commit('toast', ['is-success', this.$t('registration.success_message')]);
                        setTimeout(() => {
                            this.$router.push('/');
                            this.$store.commit('toast', []);
                        }, 2000);
                    } else {
                        this.$store.commit('toast', ['is-danger', this.$t('registration.failed_message')]);
                        setTimeout(() => {
                            this.$store.commit('toast', []);
                        }, 10000);
                    }
                } else {
                    console.error('Expected JSON, but received:', contentType);
                    this.registerUserEnabled = false;
                }
            } catch (error) {
                console.error('Failed to check registration status', error);
                this.registerUserEnabled = false;
            }
        },
        showErrorsState(field) {
            if (this.showErrors) {
                if (field === 'email' && this.user.email === '') {
                    return true;
                }
                if (field === 'password' && (this.user.password === '' || this.passwordsNotEqual === true || this.user.password.length < 8)) {
                    return true;
                }
                if (field === 'confirmPassword' && (this.user.confirmPassword === '' || this.passwordsNotEqual === true || this.user.confirmPassword.length < 8)) {
                    return true;
                }
                if (field === 'firstName' && this.user.firstName === '') {
                    return true;
                }
                if (field === 'lastName' && this.user.lastName === '') {
                    return true;
                }
                if (field === 'address' && this.user.address === '') {
                    return true;
                }
                if (field === 'phone' && (this.user.phone === '' || this.phoneFormatNotEqual === true)) {
                    return true;
                }
            }
            return false;
        },
        async verifyCaptcha(token) {
            const secretKey = process.env.VUE_APP_CAPTCHA_SECRET_KEY;
            const URL = 'https://www.google.com/recaptcha/api/siteverify?secret=' + secretKey + '&response=' + token;

            try {
                // Make an API call to the given URL and get the response as text
                const response = await fetch(URL);

                // Parse the response as JSON
                const jsonResponse = await response.json();

                // Return the 'success' field from the JSON response
                return jsonResponse.success;
            } catch (error) {
                console.error('Error fetching data:', error);
                return false; // You can handle the error as needed
            }
        },
        onSubmit(event) {
            this.showErrors = true;
            if (this.inputValid === false) {
                const self = this;
                grecaptcha.ready(function() {
                    grecaptcha.execute(process.env.VUE_APP_CAPTCHA_SITE_KEY, { action: 'submit' }).then(async function (token) {
                        const verifiedCaptcha = await self.verifyCaptcha(token);

                        if (verifiedCaptcha === true) {
                            await self.doRegistration();
                        }
                    });
                });
            }
        },
    },
    computed: {
        inputValid() {
            if (this.user.email === '' || this.user.password === '' || this.user.confirmPassword === '') {
                return true;
            }
            if (this.user.password.length < 8 || this.user.confirmPassword.length < 8) {
                return true;
            }
            if (this.user.firstName === '' || this.user.lastName === '' || this.user.address === '') {
                return true;
            }
            if (this.user.phone === '' || this.phoneFormatNotEqual === true) {
                return true;
            }
            if (this.passwordsNotEqual === true || this.user.locale === '') {
                return true;
            }
            return false;
        },
        passwordsNotEqual() {
            return this.user.password !== this.user.confirmPassword && this.user.password !== '' && this.user.confirmPassword !== '';
        },
        phoneFormatNotEqual() {
            return this.user.phone !== '' && /^\+\d{1,3}\d{8,12}$/.test(this.user.phone) === false;
        }
    },
    mounted() {
        const siteKey = process.env.VUE_APP_CAPTCHA_SITE_KEY;
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
        document.head.appendChild(script);
    }
};
</script>

<style scoped lang="scss">
    .control .icon.clickable {
        pointer-events: all;
        cursor: pointer;

        &:hover {
            color: #5e6d6f;
        }
    }

    .container {
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .login-form {
        width: 250px;
        margin: auto;
        text-align: center;

        .splash {
            font-size: 2em;
        }
    }

    .notification {
        padding: 1em;
        text-align: center;
        position: absolute;
        top: 1em;
        margin: auto;
        width: 40%;
        left: 0;
        right: 0;
    }

    .error {
        background-color: #ba201e !important;
        color: black !important;
    }

</style>
